document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-clia-twelfth]').forEach((section) => {
    const steps = section.querySelectorAll('.clia-twelfth__step');
    const layers = section.querySelectorAll('[data-clia-twelfth-image-layer]');

    let activeIndex = 0;

    const swapImage = (url, alt) => {
      if (layers.length < 2) return;

      const current = layers[activeIndex];
      const nextIndex = activeIndex === 0 ? 1 : 0;
      const next = layers[nextIndex];

      if (!url || current.src === url) return;

      const preload = new Image();
      preload.onload = () => {
        next.src = url;
        next.alt = alt || '';
        next.removeAttribute('aria-hidden');
        current.setAttribute('aria-hidden', 'true');

        next.classList.add('clia-twelfth__image--active');
        current.classList.remove('clia-twelfth__image--active');

        activeIndex = nextIndex;
      };
      preload.src = url;
    };

    steps.forEach((step) => {
      step.addEventListener('toggle', () => {
        if (!step.open) return;

        steps.forEach((other) => {
          if (other !== step) other.open = false;
        });

        const imageUrl = step.dataset.stepImageUrl;
        if (!imageUrl) return;

        const stepTitle = step.querySelector('.clia-twelfth__step-title');
        swapImage(imageUrl, stepTitle ? stepTitle.textContent.trim() : '');
      });
    });
  });
});
